import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("truck_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/") && window.location.pathname.startsWith("/app")) {
      localStorage.removeItem("truck_token");
      window.location.href = "/login?expired=1";
    }
    // Card-required gate: the API refuses paid routes until a Stripe trial/subscription exists.
    if (status === 402 && window.location.pathname.startsWith("/app") && !window.location.pathname.startsWith("/app/billing")) {
      window.location.href = "/app/billing?start=1";
    }
    return Promise.reject(err);
  }
);

export default client;
